<template>
  <div class="px-4 py-5 sm:px-6">
    <h3 class="text-lg leading-6 font-medium text-gray-900">
      {{ title }}
    </h3>
    <p class="mt-1 max-w-2xl text-sm text-gray-500">
      {{ subTitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'DescriptionHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style scoped>

</style>
